import OtherLayout from "../secrets-web/src/layouts/other";

export default OtherLayout;